export default {"src":"/_next/static/media/expressLogo.e34ac1f5.svg","height":58,"width":138};